import React, { Component, Fragment } from 'react';
import * as HMS from "../../../common/component/Index";
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import * as Func from '../../../../../helpers/functions';
import HomestayRate from "../../../../../models/HomestayRate.js";
import isEqual from "lodash/isEqual";
import { DETAIL_ACTIONS, PATHS, FEATURE_FLAGS, HOMESTAY, RATE_ENUM, DATE_TIME_FORMAT } from '../../../../../constants/Define';
import { cloneDeep, isEmpty, toArray } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import Wrapper from '../../../common/component/Wrapper';
import { Input, Switch, Icon, InputNumber, Button, Tooltip, Tag, message } from 'antd';
import './style.less';
import CONFIG from '../../../../../constants/Config';
import EllipsisText from '../../../common/component/EllipsisText';
import moment from 'moment';
import AutoTranslateField from './Components/AutoTranslateField';
import * as HomestayRateService from "../../../../../services/homestayRateService.js";
import HomestayRateTranslate from '../../../../../models/HomestayRateTranslate.js';

const ListCols = ['rangeDate', 'from', 'to', 'daysBeforeArrival', 'amount', 'type', 'isActive'];
class TableCancelPolicy extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['from', 'to', 'isActive']),
            componentTable: {
                rangeDate: {
                    key: 'rangeDate',
                    width: 200,
                    render: (text, record) => (
                        <span>{record.from && moment(record.from).format(DATE_TIME_FORMAT.SHORT_DATE)}
                         { record.to && ` - ${moment(record.to).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                        </span>
                    ),
                },
                daysBeforeArrival: {
                    key: 'daysBeforeArrival',
                    width: 150,
                },
                amount: {
                    key: 'amount',
                    width: 120,
                    render: (text, record, idx) => {
                        return(
                            this.state.indexEdit === idx ?
                                <InputNumber
                                    style={{width: '100%'}}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    name={`amount`}
                                    value={record.amount}
                                    onChange={(e) => this.onChange('amount', idx, e)}
                                />
                                : <div>{Func.formatMoney(record.amount)}</div>
                        )
                    },
                },
                type: {
                    key: 'type',
                    width: 120,
                    render: (text, record, idx) => {
                        return(
                            this.state.indexEdit === idx ?
                                <AntSelect className="select-types"
                                    showArrow
                                    placeholder={ Func.capitalizeFirstLetter((this.props.t('placeHolderForm.select') + " " + this.props.t("item.homestayRate.cancelPolicy.value")).toLowerCase()) }
                                    value={record.type}
                                    onChange={ channel => this.onChange('type', idx, channel) }
                                    style={ { width: '100%' } }
                                >
                                    { this.getValueEnums().map(vl => (
                                        <AntOption key={ vl.id } value={ vl.value }>
                                            { this.props.t(`item.homestayRate.cancelPolicyObject.valueOption.${vl.label}`) }
                                        </AntOption>
                                    )) }
                                </AntSelect>
                                : <div>
                                    { RATE_ENUM.VALUE_CANCEL_POLICY[record.type] &&
                                    this.props.t(`item.homestayRate.cancelPolicyObject.valueOption.${RATE_ENUM.VALUE_CANCEL_POLICY[record.type].label}`) }
                                </div>
                        )
                    },
                },
                action: {
                    align: 'center',
                    key: 'isActive',
                    width: 100,
                    render: (text, record, idx) => {
                        return(
                            this.state.indexEdit !== idx ? <Switch
                                checked={record.isActive}
                                onChange={(value, e) => this.onChange('isActive', idx, value)}
                                name={`isActive`}
                            />
                            :  <Icon
                                type={this.props.homestayRateState.isFetchingCancelPolicy ? "loading" : "check"}
                                className="policy-update-btn"
                                onClick={()=>this.onUpdateCancelPolicy(this.state.arrCancelPolicy)}
                            />
                        )
                    },
                }
            },
            indexEdit: null,
            arrCancelPolicy: []
        };
    }

    componentDidMount(){
        if(this.props.cancelPolicyData){
            this.setState({arrCancelPolicy: this.props.cancelPolicyData.details || []});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.cancelPolicyData, this.props.cancelPolicyData)) {
            this.setState({
                arrCancelPolicy: nextProps.cancelPolicyData ? nextProps.cancelPolicyData.details : [],
            });
        }
    }

    getValueEnums() {
        return toArray(RATE_ENUM.VALUE_CANCEL_POLICY);
    }

    onChange = (field, idx, value) => {
        let arrCancelPolicy = this.state.arrCancelPolicy;
        if(arrCancelPolicy.length > 0){
            arrCancelPolicy[idx][field] = value;
        }
        if(field === 'isActive'){
            this.onUpdateCancelPolicy(arrCancelPolicy);
        }
        this.setState({ arrCancelPolicy });
    };

    handleRowSelection = (value)=>{
       this.setState({indexEdit: value});
    }

    onUpdateCancelPolicy = (arrCancelPolicy)=>{
        const { cancelPolicyData } = this.props;
        const { match } = this.props;
        let request = {
            ...cancelPolicyData,
            details: arrCancelPolicy
        }
        match.params.id && this.props.updateCancelPolicys(request, match.params.id);
        this.setState({indexEdit: null, arrCancelPolicy: this.props.cancelPolicyData.details});
    }

    onSyncRRMCancelPolicy = ()=>{
        // const { refId } = this.props;
        const { match } = this.props;
        let request = {
            hotelId: match.params.homestay_id,
            ratePlanId:  match.params.id
        }
        match.params.homestay_id && match.params.id && this.props.syncCancelPolicys(request, match.params.id);
    }

    render(){
        const { t, homestayRateState } = this.props;
        const {
            componentTable,
            titleItemTable,
            arrCancelPolicy
        } = this.state;

        return(
            <div className="component-table-cancel-policy">
                <div className="header-policy">
                    <div className="left-policy">
                        {t(`item.homestayRate.cancelPolicyObject.tableValue`)}&nbsp;
                        {this.props.cancelPolicyData && <Tag color="green">
                            {this.props.cancelPolicyData?.id}
                        </Tag>}
                    </div>
                    <div className="right-policy">
                        <Tooltip title={t(`item.homestayRate.cancelPolicyObject.sync`)}>
                            <Icon type="sync" onClick={()=>this.onSyncRRMCancelPolicy()}/>
                        </Tooltip>
                    </div>
                </div>

                <HMS.ListComponent
                    tableKey="room-type-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    loading={{ spinning: homestayRateState.isFetchingCancelPolicy, size: 'large' }}
                    dataSource={ Func.getDataSource(arrCancelPolicy || [], ListCols) }
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'homestayRate.cancelPolicyObject'
                    })}
                    bordered
                    onRow={(record, index) => ({
                        onDoubleClick: (e) => this.handleRowSelection(index)
                    })}
                />
            </div>
        )
    }
}

class DescriptionHomestayRate extends Component {
    constructor(props){
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(['icon', 'shortDescription'], ['action'], []),
            componentTable: {
                icon: {
                    key: 'icon',
                    render: (icon, record)=> {
                        return icon && <img width={20} alt="" src={icon}/>
                    }
                },
                shortDescription: {
                    key: 'shortDescription',
                    render: (shortDescription)=> shortDescription &&
                    <EllipsisText title={shortDescription} content={shortDescription} contentMaxWidth={280} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                action: {
                    width: 100,
                    key: 'action',
                    align: 'center',
                    render: (text, record, idx)=> <Icon type="delete" style={{cursor: 'pointer'}}
                        onClick={()=>this.removeItem(idx)}
                    />
                }
            },
            arrShortDescription: [],
            description: {
                icon: null,
                shortDescription: null
            }
        }
    }

    componentDidMount(){
        if(this.props.shortDescription){
            let arrTmp = this.props.shortDescription;
            if(typeof this.props.shortDescription === 'string'){
                arrTmp = [{icon: null, shortDescription: this.props.shortDescription}];
            }
            this.setState({arrShortDescription: arrTmp || []});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.shortDescription, this.props.shortDescription)) {
            let arrTmp = nextProps.shortDescription;
            if(typeof nextProps.shortDescription === 'string'){
                arrTmp = [{icon: null, shortDescription: nextProps.shortDescription}];
            }
            this.setState({arrShortDescription: arrTmp || []});
        }
    }

    onAddDescription = ()=>{
        const { arrShortDescription, description } = this.state;
        let arrOld = arrShortDescription;
        if(description.icon && description.shortDescription.trim()){
            if(description.icon){
                const { amenityState } = this.props;
                const { amenities } = amenityState;
                const findIndex = amenities.findIndex(item => item.id === description.icon);
                description['icon'] = amenities[findIndex].url ? this.convertUrlImage(amenities[findIndex].url) : '';
            }

            arrOld = [
                ...arrShortDescription,
                description
            ]
            this.props.addDescription(arrOld);
            this.setState({
                arrShortDescription: arrOld ,
                description: {
                    icon: null,
                    shortDescription: null
                }
            });
        }
    }

    removeItem = (idx)=>{
        const { arrShortDescription } = this.state;
        if(idx !== null){
            arrShortDescription.splice(idx, 1);
            this.setState({arrShortDescription})
            this.props.addDescription(arrShortDescription);
        }
    }

    onChange = (fieldName, value)=>{
        const { description } = this.state;
        description[fieldName] = value;
        this.setState({ description })
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode((option?.props?.children[0] || '').toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    convertUrlImage(url) {
        return url.includes('https://') ? url : `https://${url}`
    }

    render(){
        const {
            titleItemTable,
            componentTable,
            arrShortDescription,
            description
        } = this.state;

        const { t, amenityState } = this.props;
        const { amenities, isFetching } = amenityState;

        return(
            <div>
                <div className="row">
                    <Wrapper className="col-md-5">
                        <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.homestayRate.descriptionHomestayRate.icon`)}
                        >
                            <AntSelect className="select-departure"
                                showArrow showSearch
                                disabled={this.props.disabled}
                                suffixIcon={<Icon type="search" />}
                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.bundle.campaign")).toLowerCase()) }
                                onChange={ (e) => {
                                    const iconNameFill = (amenities || []).find(item => item.id === e);
                                    this.onChange('icon', e);
                                    this.onChange('shortDescription', iconNameFill?.name)
                                } }
                                style={ { width: '100%' } }
                                value={ description.icon }
                                loading={ isFetching }
                                filterOption={ (inputValue, option) => this.selectFilterSearch(inputValue, option) }
                            >
                                { (amenities || []).filter(item => item.isActive).map(a => (
                                    <AntOption key={ a.id } value={ a.id }>
                                       {a.name} &nbsp;&nbsp;{a.url && <img width={20} src={this.convertUrlImage(a.url)}/>}
                                    </AntOption>
                                )) }
                            </AntSelect>
                        </HMS.FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-5">
                        <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.homestayRate.descriptionHomestayRate.shortDescription`)}
                        >
                            <Input placeholder="" type={`text`}
                                disabled={this.props.disabled}
                                className={`form-control`}
                                name={`name`} onChange={(e) => this.onChange('shortDescription', e.target.value)}
                                value={Func.checkUndefine(description.shortDescription)}
                            />
                        </HMS.FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-2 button-add-center-homestayRate">
                        <Button disabled={!description.icon || !description.shortDescription || (description.shortDescription && !description.shortDescription.trim())} type="primary" onClick={this.onAddDescription}>{t(`item.homestayRate.descriptionHomestayRate.add`)}</Button>
                    </Wrapper>
                </div>
                <HMS.ListComponent
                    tableKey="room-type-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={ Func.getDataSource(arrShortDescription || [], ['icon', 'shortDescription']) }
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'homestayRate.descriptionHomestayRate'
                    })}
                    bordered
                />
            </div>
        )
    }
}

export default class RoomTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            action: this.props.match.params.id ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            homestayRate: new HomestayRate(),
            validation: {},
            isUploading: false,
            isReady: !this.props.match.params.id //Render when create
        };
    }

    onChange = (field, value) => {
        const homestayRate = this.state.homestayRate;
        if(field === 'cancelPolicy'){
            homestayRate[field].description = value;
        }else{
            homestayRate[field] = value;
        }
        this.setState({ homestayRate, isSubmit: false });
    };

    _addDescription = (arr)=>{
        this.onChange('shortDescription', arr);
    }

    componentDidMount() {
        const { match } = this.props;
        match.params.id && this.props.getHomestayRate(match.params.id);
        this.props.getListAmenities();
    }

    onClickBack = () => {
        const { match } = this.props;
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            if (Object.keys(match.params).length > 0 && match.params.homestay_id) {
                const path = Func.getPathWithParams(PATHS.HOMESTAY_RATE.LIST.path, { homestay_id: match.params.homestay_id })
                this.props.history.push(path);
            }
        }
    }

    onShowTranslate = (language) => {
        const { homestayRate } = this.state;
        homestayRate.setTranslate(language.code);
        homestayRate.setData();
        this.setState({ homestayRate, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = (isUpdateTrans = false) => {
        const homestayRate = cloneDeep(this.state.homestayRate);
        const action = DETAIL_ACTIONS[homestayRate.id ? 'UPDATE' : 'CREATE'];
        // if(isUpdateTrans)
        homestayRate.setTranslate(undefined, true);
        homestayRate.setData();
        this.setState({ homestayRate, action });
    }

    onSaveTranslate = () => {
        const { homestayRate } = this.state;
        const getDataTranslation = homestayRate.translations.filter(item => item.languageCode === homestayRate.translate.languageCode)
        const translateFunction = getDataTranslation.length > 0 ? this.props.updateHomestayRateTranslate : this.props.createHomestayRateTranslate;
        translateFunction(homestayRate, homestayRate.languageCode);
        this.onExitTranslate(true);
    }

    onRemoveTranslate = (language) => {
        const { homestayRate } = this.state;
        homestayRate.setTranslate(language.code);
        this.props.deleteHomestayRateTranslate(homestayRate, { id: homestayRate.id });
    }

    onSubmit = async (e) => {
        e.preventDefault();
        // this.props.createHomestayRateTranslate(this.state.homestayRate, 'vi-VN');
        const { homestayRate } = this.state;
        // Get API Auto Translate
        if(!isEmpty(homestayRate.targetLanguage)){
            try {
                const bodyTranslate = new HomestayRateTranslate(homestayRate);
                const cloneBody = cloneDeep(bodyTranslate.export());
                cloneBody.ratePlanId = cloneBody.homestayRatePlanId;
                delete cloneBody.homestayRatePlanId;
                const resTranslate = await HomestayRateService.updateAutoTranslate(cloneBody);
                if(resTranslate) {
                    message.success('Translate thành công')
                }
            } catch (error) {
                const messageError = error && error?.data?.errors?.[0]?.message;
                return message.error(messageError);
            }
        }
        delete homestayRate['targetLanguage']
        //
        const getDataTranslation = homestayRate.translations.filter(item => item.languageCode === homestayRate.translate.languageCode)
        const translateFunction = getDataTranslation.length > 0 ? this.props.updateHomestayRateTranslate : this.props.createHomestayRateTranslate;
        translateFunction(homestayRate, homestayRate.languageCode);
        this.onExitTranslate();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.homestayRateState.homestayRate && !isEqual(nextProps.homestayRateState.homestayRate, this.props.homestayRateState.homestayRate) && !nextProps.homestayRateState.isFetching) {
            this.setState({
                homestayRate: nextProps.homestayRateState.homestayRate,
                isReady: true,
                loading: false,
                isSubmit: false
            });
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestayRate.name`)),
                description: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestayRate.description`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.homestayRate, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    isDisableField(fieldName = '') {
        // const {homestayRate} = this.state;
        // const defaultLanguage = ["vi-VN", "en-US"];
        // const languageTranslation = homestayRate.translations.find(e => e.languageCode === homestayRate.languageCode);
        // const isDefaultLang  = defaultLanguage.includes(languageTranslation?.languageCode);
        // if (!fieldName) {
        //     return !isDefaultLang;
        // }
        // return Boolean(homestayRate[fieldName] && !isDefaultLang);
        return false;
    }

    render() {
        const { t, match } = this.props;
        const { action, homestayRate, isReady, isSubmit, validation } = this.state;
        return (
            <Fragment>{isReady &&
                <HMS.PageListComponent className="homestayRate-detail">
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'room-types'}
                        titleHeader={Func.capitalizeFirstLetter((`${t(action === DETAIL_ACTIONS.CREATE ? 'action.create' : 'action.update')} ${t('item.homestayRate.title')}`).toLowerCase())}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={homestayRate.translations}
                                current={homestayRate.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange({ name: 'languageCode', value: language.code })}
                                disabledActionRemove
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <HMS.FormActionComponent
                        additionalButton={<AutoTranslateField languageCode={homestayRate?.languageCode || 'vi-VN'} onChange={this.onChange} targetLanguage={homestayRate?.targetLanguage}/>}
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={false}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={t(`action.save`)}
                        activeComponent={false}
                        submitButtonRight={true}
                    >
                        <div className="basic-info">
                            <div className="basic-info-box">
                                <div className="row">
                                    <Wrapper className="col-md-3">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={homestayRate.name}
                                            validation={validation.name}
                                            labelTitle={t(`item.homestayRate.name`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                disabled={this.isDisableField('name')}
                                                name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                value={Func.checkUndefine(homestayRate.name)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-3">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.homestayRate.code`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('code', e.target.value)}
                                                disabled
                                                value={Func.checkUndefine(homestayRate.code)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-3">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.homestayRate.refId`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('refId', e.target.value)}
                                                disabled
                                                value={Func.checkUndefine(homestayRate.refId)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-3">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.homestayRate.order`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('order', Number(e.target.value))}
                                                disabled
                                                value={homestayRate.order} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={homestayRate.description}
                                            validation={validation.description}
                                            labelTitle={t(`item.homestayRate.description`)}
                                        >
                                            <Input.TextArea rows={3} placeholder="" type={`text`}
                                                    className='form-control'
                                                    disabled={this.isDisableField('description')}
                                                    name='description' onChange={(e) => this.onChange('description', e.target.value)}
                                                    value={homestayRate.description} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.homestayRate.cancelPolicy`)}
                                        >
                                           <Input.TextArea rows={3} placeholder="" type={`text`}
                                                className='form-control'
                                                disabled= { true }
                                                name='cancelPolicy' onChange={(e) => this.onChange('cancelPolicy', e.target.value)}
                                                value={homestayRate.cancelPolicy?.description} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.homestayRate.shortDescription`)}
                                        >
                                            {/* <Input type="text"
                                                autoComplete="off"
                                                className="form-control" name="shortDescription" onChange={(e) => this.onChange('shortDescription', e.target.value)}
                                                value={homestayRate.shortDescription} /> */}
                                            <DescriptionHomestayRate
                                                {...this.props}
                                                disabled={this.isDisableField('shortDescription')}
                                                shortDescription={homestayRate.shortDescription}
                                                addDescription={this._addDescription}
                                            />
                                        </HMS.FormWrapperInputComponent>
                                        <Wrapper className="row">
                                            <Wrapper className="col-md-6">
                                                <HMS.FormWrapperInputComponent
                                                    labelTitle={t(`item.homestayRate.typeHomestayRate`)}
                                                >
                                                    <br />
                                                    {
                                                        homestayRate.dc.map(typeId => <span key={typeId} ><HMS.StatusComponent color={HOMESTAY.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red' }
                                                        label={HOMESTAY.TYPE_RATE[CONFIG.ENV][typeId]}/></span>)
                                                    }
                                                </HMS.FormWrapperInputComponent>
                                            </Wrapper>
                                            <Wrapper className="col-md-6">
                                                <HMS.FormWrapperInputComponent
                                                    labelTitle={t(`item.homestayRate.status`)}
                                                >
                                                    <br />
                                                    <HMS.StatusComponent color={homestayRate.refStatus ? 'green' : 'red'}
                                                        label={homestayRate.refStatus ? this.props.t('item.homestayRate.active') : this.props.t('item.homestayRate.deactive')} />
                                                </HMS.FormWrapperInputComponent>
                                            </Wrapper>
                                        </Wrapper>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <TableCancelPolicy
                                            {...this.props}
                                            cancelPolicyData={homestayRate.cancelPolicy}
                                            refId={homestayRate.refId || null}
                                        />
                                    </Wrapper>
                                    <Wrapper className="col-md-6" />
                                    <Wrapper className="col-md-6 m-t-sm">
                                        <div>
                                            <div className='col-md-3 independent'>
                                                <HMS.FormWrapperInputComponent
                                                    labelTitle={t(`item.homestayRate.isIndependent`)}
                                                    // visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                                >
                                                    <br />
                                                    <Switch checked={homestayRate.isIndependent}  onChange={(value) => this.onChange('isIndependent', value)} name={`isIndependent`} />
                                                </HMS.FormWrapperInputComponent>
                                            </div>
                                            {/* <div className='col-md-3'>
                                                <HMS.FormWrapperInputComponent
                                                    labelTitle={t(`item.homestayRate.usageStatus`)}
                                                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                                >
                                                    <br />
                                                    <Switch defaultChecked={homestayRate.usageStatus} onChange={(value) => this.onChange('usageStatus', value)} name={`usageStatus`} />
                                                </HMS.FormWrapperInputComponent>
                                            </div> */}
                                        </div>
                                    </Wrapper>
                                </div>
                            </div>
                        </div>
                    </HMS.FormActionComponent>
                </HMS.PageListComponent>
            }
            </Fragment>
        );
    }
}
